import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { HealthcareFacilitiesApi } from '../../../apis/HealthcareFacilitiesApi/HealthcareFacilitiesApi.ts';
import { useLowFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useLowFrequencyRefreshQuery.tsx';

export function useGetHealthcareFacilitiesForHcp(hcpId: number | undefined) {
    return useLowFrequencyRefreshQuery({
        queryKey: [QueryKeys.healthcareFacilities, 'forHcp', hcpId],
        queryFn: async () => {
            if (!hcpId) return [];
            return await HealthcareFacilitiesApi.getHealthcareFacilitiesForHcp(hcpId);
        },
        enabled: !!hcpId,
    });
}

